module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/highExposureIcon_UB.d0c23720.svg";